import React from 'react';
import { connect } from 'react-redux';
import Notifications from 'react-notification-system-redux';

const colorDefinitions = {
  mode: { light: 'day', dark: 'night' },
  text1: { light: '#3b3e66', dark: '#d4d6d7' }, // navy text
  accent1: { light: '#0088e8', dark: '#47b3ff' },
  accent2: { light: '#f66f27', dark: '#f66f27' },
  active: { light: '#eeeeee', dark: '#5b5b5b' }, // active event
  border: { light: '#c4c4c4', dark: '#6e6e6e' },
  paper: { light: '#fff', dark: '#424242' }, // tooltip paper
  grey1: { light: '#dedfe3', dark: '#343434' }, // card background grey
  grey2: { light: '#dedfe3', dark: '#5b5b5b' }, // avatar bcackground
  grey3: { light: '#999999', dark: '#7c7c7c' }, // tooltip border color
  grey4: { light: '#f9f9f9', dark: '#393939' }, // very light grey
  grey5: { light: '#f5f5f5', dark: '#515151' }, // light grey used in menu hover
  grey6: { light: '#666', dark: '#999' }, // text lighter
  orange1: { light: '#FFA500', dark: '#FFA500' },
  primary: { light: '#0153a3', dark: '#778eeb' },
  secondary: { light: '#1e8dfa', dark: '#808080' },
  info: { light: '#2196f3', dark: '#2196f3' },
  success: { light: '#43a047', dark: '#43a047' },
  error: { light: '#d32f2f', dark: '#d32f2f' },
  warning: { light: '#ff9800', dark: '#ff9800' },
  secondaryContrast: { light: '#f7f7f7', dark: '#242f3e' },
};

function getColors(themeMode) {
  const colorScheme = {};
  Object.entries(colorDefinitions).forEach(([name, values]) => {
    colorScheme[name] = values[themeMode];
  });
  return colorScheme;
}

const colorSchemeLight = getColors('light');
const colorSchemeDark = getColors('dark');

const notificationStyles = (colors) => {
  return {
    NotificationItem: {
      DefaultStyle: {
        margin: '10px 5px 2px 1px',
        borderRadius: '0.35rem',
        boxShadow:
          '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
        background: colors.paper,
        color: colors.text1,
      },
      success: {
        borderTopColor: colors.success,
      },
      info: {
        borderTopColor: colors.info,
      },
      warning: {
        borderTopColor: colors.warning,
      },
      error: {
        borderTopColor: colors.error,
      },
    },

    Title: {
      DefaultStyle: {
        textTransform: 'uppercase',
      },
      success: {
        color: colors.success,
      },
      error: {
        color: colors.error,
      },
      warning: {
        color: colors.warning,
      },
      info: {
        color: colors.info,
      },
    },

    Action: {
      DefaultStyle: {
        textTransform: 'uppercase',
        borderRadius: '0.35rem',
      },

      success: {
        backgroundColor: colors.success,
        color: '#ffffff',
      },

      error: {
        backgroundColor: colors.error,
        color: '#ffffff',
      },

      warning: {
        backgroundColor: colors.warning,
        color: '#ffffff',
      },

      info: {
        backgroundColor: colors.info,
        color: '#ffffff',
      },
    },

    Dismiss: {
      DefaultStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontFamily: 'Arial',
        fontSize: 24,
        position: 'absolute',
        top: 0,
        right: 0,
        lineHeight: 1,
        backgroundColor: 'transparent',
        color: colors.grey3,
        width: 40,
        height: 40,
        fontWeight: 400,
      },
    },
  };
};

const notificationStylesDay = notificationStyles(colorSchemeLight);
const notificationStylesNight = notificationStyles(colorSchemeDark);

function NotificationPanel(props) {
  const { notifications, themeMode } = props;
  return (
    <>
      {themeMode === 'day' && (
        <Notifications notifications={notifications} style={notificationStylesDay} />
      )}
      {themeMode === 'night' && (
        <Notifications notifications={notifications} style={notificationStylesNight} />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    themeMode: state.theme.mode,
    notifications: state.notifications,
  };
};

export default connect(mapStateToProps)(NotificationPanel);
